/**
 * Lightweight cart event bus.
 * Cart mutations emit "cart:updated" so header badge can re-fetch.
 * "cart:delta" is emitted optimistically (before server response) with a quantity delta.
 */
const CART_UPDATED_EVENT = "cart:updated"
const CART_DELTA_EVENT = "cart:delta"

export function emitCartUpdate() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event(CART_UPDATED_EVENT))
  }
}

export function onCartUpdate(callback: () => void): () => void {
  if (typeof window === "undefined") return () => {}
  window.addEventListener(CART_UPDATED_EVENT, callback)
  return () => window.removeEventListener(CART_UPDATED_EVENT, callback)
}

/**
 * Optimistically update the cart badge count by `delta` items.
 * Use before the server call so the badge updates instantly.
 * A full refresh via emitCartUpdate() should follow after the server responds.
 */
export function emitCartDelta(delta: number) {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(CART_DELTA_EVENT, { detail: { delta } }))
  }
}

export function onCartDelta(callback: (delta: number) => void): () => void {
  if (typeof window === "undefined") return () => {}
  const handler = (e: Event) => callback((e as CustomEvent<{ delta: number }>).detail.delta)
  window.addEventListener(CART_DELTA_EVENT, handler)
  return () => window.removeEventListener(CART_DELTA_EVENT, handler)
}
